import React from "react";

export default function OrgPortalSectionTitle({ title, theme, withBar = false }) {
    const { accentColor, primaryColor } = theme;

    const sectionTitleStyle = {
        color: primaryColor,
        marginBottom: 16,
        fontWeight: 600,
        fontSize: 20,
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
    };

    const accentBar = {
        display: "inline-block",
        width: 40,
        height: 3,
        borderRadius: 999,
        backgroundColor: accentColor,
    };

    return (
        <h3 style={sectionTitleStyle}>
            <span>{title}</span>
            {withBar && <span style={accentBar} />}
        </h3>
    );
}